<div *ngFor="let entry of entries">

  <a [href]="entry.link" target="_new">
    <div class="row faketablerow noclick" >
      <div class="col-2 faketablecell my-auto">
          <fa-icon [icon]="['fas', 'newspaper']" size="3x" *ngIf="type === 'news'"></fa-icon>
          <fa-icon [icon]="['fas', 'blog']" size="3x" *ngIf="type === 'blog'"></fa-icon>
          <fa-icon [icon]="['fas', 'calendar-alt']" size="3x" *ngIf="type === 'event'"></fa-icon>
          <fa-icon [icon]="['fas', 'scroll']" size="3x" *ngIf="type === 'whitepaper'"></fa-icon>
      </div>
      <div class="col-8 faketablecell" style="text-align: left;">
        <p class="list-title">{{entry.title}}</p>
        <p class="list-text" [innerHTML]="entry.description"></p>
      </div>
      <div class="col-2 faketablecell">{{ entry.pubDate | date:'dd/MM/yyyy HH:mm' }}</div>
    </div>
  </a>

</div>

<div class="row justify-content-center p-5" *ngIf="!loaded">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
  </div>
</div>

<div class="row p-3 justify-content-center redborder-sides" *ngIf="entries && entries.length == 0">
  <div class="col-md-12 table-border justify-content-center">
    {{ 'pages.rss.dashboard.noResults' | translate }}
  </div>
</div>
